export default [
  {
    component: () => import('../pages/dashboard-page.vue'),
    name: 'dashboard',
    path: '/:slug/dashboard',
  },
]
